// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { HistoryFeedInfoFragmentDoc } from '../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type JobLogNoteHistoryTabQueryVariables = Types.Exact<{
  jobLogNoteId: Types.Scalars['ID']['input'];
}>;


export type JobLogNoteHistoryTabQuery = { __typename?: 'Query', jobLogNote: { __typename?: 'JobLogNote', id: string, history: Array<{ __typename?: 'History', avatar: string, title: string, subtitle?: string | null | undefined, recordedAt: Types.Scalars['DateTime']['input'], userName?: string | null | undefined }> } };


export const JobLogNoteHistoryTabDocument = gql`
    query JobLogNoteHistoryTab($jobLogNoteId: ID!) {
  jobLogNote(id: $jobLogNoteId) {
    id
    history {
      ...HistoryFeedInfo
    }
  }
}
    ${HistoryFeedInfoFragmentDoc}`;

/**
 * __useJobLogNoteHistoryTabQuery__
 *
 * To run a query within a React component, call `useJobLogNoteHistoryTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobLogNoteHistoryTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobLogNoteHistoryTabQuery({
 *   variables: {
 *      jobLogNoteId: // value for 'jobLogNoteId'
 *   },
 * });
 */
export function useJobLogNoteHistoryTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<JobLogNoteHistoryTabQuery, JobLogNoteHistoryTabQueryVariables> & ({ variables: JobLogNoteHistoryTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<JobLogNoteHistoryTabQuery, JobLogNoteHistoryTabQueryVariables>(JobLogNoteHistoryTabDocument, options);
      }
export function useJobLogNoteHistoryTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JobLogNoteHistoryTabQuery, JobLogNoteHistoryTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<JobLogNoteHistoryTabQuery, JobLogNoteHistoryTabQueryVariables>(JobLogNoteHistoryTabDocument, options);
        }
// @ts-ignore
export function useJobLogNoteHistoryTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<JobLogNoteHistoryTabQuery, JobLogNoteHistoryTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<JobLogNoteHistoryTabQuery, JobLogNoteHistoryTabQueryVariables>;
export function useJobLogNoteHistoryTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<JobLogNoteHistoryTabQuery, JobLogNoteHistoryTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<JobLogNoteHistoryTabQuery | undefined, JobLogNoteHistoryTabQueryVariables>;
export function useJobLogNoteHistoryTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<JobLogNoteHistoryTabQuery, JobLogNoteHistoryTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<JobLogNoteHistoryTabQuery, JobLogNoteHistoryTabQueryVariables>(JobLogNoteHistoryTabDocument, options);
        }
export type JobLogNoteHistoryTabQueryHookResult = ReturnType<typeof useJobLogNoteHistoryTabQuery>;
export type JobLogNoteHistoryTabLazyQueryHookResult = ReturnType<typeof useJobLogNoteHistoryTabLazyQuery>;
export type JobLogNoteHistoryTabSuspenseQueryHookResult = ReturnType<typeof useJobLogNoteHistoryTabSuspenseQuery>;
export type JobLogNoteHistoryTabQueryResult = Apollo.QueryResult<JobLogNoteHistoryTabQuery, JobLogNoteHistoryTabQueryVariables>;